import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useStyles } from './bannerInterface.module';
import ButtonDefault from '../../shared/button/button';
import { Grid, Typography } from '@material-ui/core';

const BannerInterface = (props) => {
  const classes = useStyles(props);

  const {
    bannerTitle = [],
    descriptionTexts = [],
    buttonText = '',
    buttonAction = () => {},
    showButton = true,
  } = props;

  useEffect(() => {
    const img = new Image();
    img.src = props.backgroundImg;
  }, [props.backgroundImg]);

  return (
    <Grid container className={classes.containerSlide}>
      <Grid
        container
        item
        className={classes.contentSlide}
        lg={12}
        md={12}
        sm={12}
        xs={12}
      >
        <Grid item lg={1} md={1} sm={1} xs={1} />

        <Grid item lg={10} md={10} sm={10} xs={10}>
          {bannerTitle.map((text, index) => (
            <Typography key={`title-${index}`} paragraph={index > 0}>
              <span className={classes.comingSoon}>{text}</span>
            </Typography>
          ))}

          <div>
            {descriptionTexts.map((text, index) => (
              <div key={`desc-${index}`}>
                <span className={classes.text}>{text}</span>
              </div>
            ))}
          </div>

          {showButton && buttonText && (
            <div className={classes.buttonSlide}>
              <ButtonDefault
                type="buttonBarnerMain"
                text={buttonText}
                changeView={buttonAction}
              />
            </div>
          )}
        </Grid>

        <Grid item lg={1} md={1} sm={1} xs={1} />
      </Grid>
    </Grid>
  );
};

BannerInterface.propTypes = {
  bannerTitle: PropTypes.arrayOf(PropTypes.string),
  descriptionTexts: PropTypes.arrayOf(PropTypes.string),
  buttonText: PropTypes.string,
  buttonAction: PropTypes.func,
  showButton: PropTypes.bool,
  backgroundImg: PropTypes.string,
};

BannerInterface.defaultProps = {
  bannerTitle: [],
  descriptionTexts: [],
  buttonText: '',
  buttonAction: () => {},
  showButton: true,
  backgroundImg: '',
};

export default BannerInterface;
